import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="game"
export default class extends Controller {
  connect() {
  }

  clear(event) {
    event?.preventDefault()

    this.element.querySelectorAll("input, select, textarea").forEach((el) => {
      const type = el.type

      if (type === "hidden" || type === "submit" || type === "button" || type === "reset") {
        return
      }

      if (type === "checkbox" || type === "radio") {
        el.checked = false
      } else if (el.tagName === "SELECT") {
        el.selectedIndex = 0
      } else {
        el.value = ""
      }
    })
  }
}
